












import { defineComponent, PropType, computed } from '@vue/composition-api';

import useMessageImage from '@/composables/useMessageImage';

// types
import { MessageAttachment } from '@/views/Admin/Channels/channelTypes';

export default defineComponent({
    props: {
        attachment: {
            type: Object as PropType<MessageAttachment>,
            required: true,
        },
    }, 
    setup(props, { emit }) {

        const { imageData } = props.attachment.storageGuid ?  useMessageImage(props.attachment.storageGuid) : {imageData: null};

        const imageRatio = computed(() => {
            return props.attachment.width / props.attachment.height;
        });

        const storageGuid = computed(() => {
            return props.attachment.storageGuid;
        });

        return {
            imageData,
            imageRatio,
            storageGuid,
        };
    },
});
